<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialog"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Vytvořit nový produkt</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>{{activeItem.datum | formatDate}}</h3>
                <h3 class="mt-2">{{activeItem.identifikace}}</h3>
                <h3 class="mt-3" v-html="th.makeText(activeItem.predmet)"></h3>
                <p class="mt-3 pa-0" v-if="activeItem.popis!=null&&activeItem.popis.length>0" v-html="th.makeText(activeItem.popis)"></p>
                <p class="mt-3 pa-0" v-if="activeItem.stack_trace!=null&&activeItem.stack_trace.length>0" v-html="th.makeText(activeItem.stack_trace)"></p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-3 elevation-0" @click="dialog=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Log</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm4>
                <v-text-field
                  label="Hledat dle identifikace nebo předmětu"
                  class="mx-2"
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.datum | formatDate }}</td>
                  <td>{{ props.item.identifikace }}</td>
                  <td><div v-html="th.makeText(props.item.predmet)"></div></td>
                  <td class="text-xs-center">
                    <v-btn color="primary" class="elevation-0" v-if="(props.item.popis!=null&&props.item.popis.length>0) || (props.item.stack_trace!=null&&props.item.stack_trace.length>0)" @click="showClick(props.item)">
                      <v-icon small class="mr-2">remove_red_eye</v-icon>
                      Detail
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      updateItem: {},
      headers: [
        { text: 'ID', value: 'id', width: '30px' },
        { text: 'Datum', value: 'datum' },
        { text: 'Identifikace', value: 'identifikace', sortable: false},
        { text: 'Předmět', value: 'predmet', sortable: false},
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      loadingTable: true,
      search: "",
      material: null,
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      items: [],
      dialog: false,
      activeItem: null
    }
  },
  computed: {
    th () {
      return window.th;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    search () {
      this.queryList();
    },
    pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("log/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    showClick (v) {
      this.activeItem = v;
      this.dialog = true;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TestTools/Log.vue